/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:1f0b046a-e6fa-4106-ac86-28f1e533e1a7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_lZAgJ0G8A",
    "aws_user_pools_web_client_id": "6quspomsbckbgn4ci87k9dm6in",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://52to4crpjzasjd5jkiyczl4bjq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-a6vhzowtqrf7bgffad5h7f2sli",
    "aws_user_files_s3_bucket": "birthdaygift8e151e3ade6e40db94fca8e182a59817232722-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
